import React from "react";
import "./SectionTitle.css";

interface SectionTitleProps {
    title: React.ReactNode;
    extra?: React.ReactNode;
}

const SectionTitle: React.FC<SectionTitleProps> = function (props) {
    const { title, extra } = props;

    return (
        <div className="manual-order-section-title">
            <i className="manual-order-section-title-icon" />
            <span>{title}</span>
            {extra ? <span className="manual-order-section-title-extra">{extra}</span> : null}
        </div>
    );
};

export default SectionTitle;
